import React, { memo } from 'react';
import StreetAddress from './Formats/StreetAddress';
import ForeignAddress from './Formats/ForeignAddress';
import PostBoxAddress from './Formats/PostBoxAddress';
import UnstructuredAddress from './Formats/UnstructuredAddress';
import FreeTextAddress from './Formats/FreeTextAddress/FreeTextAddress';
import { AddressFormats } from '../../Enums/AddressFormats';

const AddressFormatSwitcher = ({ addressState, getCommonFields, modalMode, countryList, setAddressState }) => {
  return (
    <>
      {addressState.address?.format === AddressFormats.Street ? (
        <StreetAddress
          modalMode={modalMode}
          getCommonFields={getCommonFields}
          addressState={addressState}
          countryList={countryList}
          setAddressState={setAddressState}
        />
      ) : addressState.address?.format === AddressFormats.Foreign ? (
        <ForeignAddress
          modalMode={modalMode}
          getCommonFields={getCommonFields}
          addressState={addressState}
          countryList={countryList}
          setAddressState={setAddressState}
        />
      ) : addressState.address?.format === AddressFormats.POBox ? (
        <PostBoxAddress
          modalMode={modalMode}
          getCommonFields={getCommonFields}
          addressState={addressState}
          countryList={countryList}
          setAddressState={setAddressState}
        />
      ) : addressState.address?.format === AddressFormats.Unstructured ? (
        <UnstructuredAddress
          modalMode={modalMode}
          getCommonFields={getCommonFields}
          addressState={addressState}
          countryList={countryList}
          setAddressState={setAddressState}
        />
      ) : addressState.address?.format === AddressFormats.FreeText ? (
        <FreeTextAddress
          modalMode={modalMode}
          getCommonFields={getCommonFields}
          addressState={addressState}
          countryList={countryList}
          setAddressState={setAddressState}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(AddressFormatSwitcher);
